import React, { Component } from 'react';
import { List, Pagination, Button, Row } from 'antd';
import { app, api } from "../../../app";

class TeamDynamic extends Component {
    constructor (props) {
        super(props);
        console.log(props);
        this.state = {
            dataList: [],
            data_loading: true,
            page: 1,
            total: 0,
            teamno: props.match.params.teamno,
            teamname: "正在加载 ... "
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleData = async (page = 1) => {
        await this.setData({ page, data_loading: true });
        let { teamno } = this.state,
            params = {
                page,
                teamno,
                request: "team",
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total, teamname } = await app.post(api.TeamDynamicsList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (page === this.state.page) {
            this.setData({ teamname, data_loading: false, dataList: data, total: parseInt(total || 0) });
        }
    };

    render () {
        let { data_loading, teamname, dataList, total, page } = this.state;
        return (
            <div className="dynamic-page">
                <Row className="dynamic-title" type="flex" justify="space-between">
                    <span>最新动态</span>
                    <Button type="primary" onClick={() => this.props.history.go(-1)}>返回</Button>
                </Row>
                <div className="dp-content">
                    <div className="dp-title">{teamname}</div>
                    <List
                        itemLayout="vertical"
                        locale={app.tbLocale(data_loading)}
                        loading={data_loading}
                        className="dp-list"
                        dataSource={dataList}
                        renderItem={item => (
                            <List.Item
                                key={item.id}
                                extra={item.submit_time}
                                style={{ textAlign: "left", padding: "16px 20px 0 20px" }}
                            >{item.dynamics_content}</List.Item>
                        )}
                    />
                    <Pagination
                        total={total}
                        current={page}
                        pageSize={20}
                        size="small"
                        showTotal={(total) => `总数量：${total}`}
                        onChange={this.handleData}
                        style={{ textAlign: "center", padding: 20 }}
                    />
                </div>
            </div>
        );
    }
}

export default TeamDynamic;



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TeamDynamic.jsx